(function (Drupal) {
  Drupal.behaviors.kafRecipeAjaxLoad = {
    /**
     * attach()
     *
     * Initialize the behavior.
     * @see Drupal.attachBehaviors()
     */
    attach: function (context) {
      if (context !== document) {
        return;
      }

      if (!this.initialized) {
        this.initialize();
      }
    },

    /**
     * initialize()
     */
    initialize: function () {
      this.initialized = true;
      this.buildIframe();
    },

    buildIframe: function () {
      // Get print button
      const printButton = document.getElementById('print-recipe-button');

      if (printButton) {
        const nodeID = printButton.getAttribute('data-node');
        const iframeCont = document.createElement('div');
        const iframe = document.createElement('iframe');
        const closeButton = document.createElement('button');

        closeButton.innerHTML = `<b class="icon-close--bold"></b>`;
        closeButton.setAttribute('id', 'print-recipe--close-button');
        closeButton.setAttribute('class', 'print-recipe--modal-close-button');
        closeButton.setAttribute('aria-label', 'print recipe modal close button');

        iframeCont.setAttribute('id', 'print-recipe--container');
        iframeCont.setAttribute('class', 'print-recipe--modal-container');
        iframeCont.setAttribute('aria-hidden', 'true');
        iframeCont.style.display = 'none';

        iframe.setAttribute('id', 'print-recipe--iframe');
        iframe.setAttribute('class', 'print-recipe--modal-iframe');
        iframe.setAttribute('frameborder', 0);
        iframe.src = `/recipes/print/${nodeID}`;

        iframeCont.appendChild(iframe);
        iframeCont.appendChild(closeButton);
        document.body.appendChild(iframeCont);

        printButton.addEventListener('click', e => {
          iframeCont.style.display = 'block';
          iframeCont.setAttribute('aria-hidden', 'false');
        });

        closeButton.addEventListener('click', e => {
          iframeCont.style.display = 'none';
          iframeCont.setAttribute('aria-hidden', 'true');
        });
      }
    },
    /**
     * Initialized state.
     */
    initialized: false,
  };
})(Drupal);
